
export const isNumericField = (fieldKey: string) =>
    ['block_amount', 'cash_threshold_limit', 'scheme', 'category', 'group', 'distributor', 'distributor_share', 'client_class', 'country_id', 'old_client'].includes(fieldKey);

export const isBooleanField = (fieldKey: string) =>
    ['is_nri', 'is_active', 'stop_purchase', 'redemption_only', 'clearing_cash_enable', 'is_derivative_consent', 'fa_fees_to_be_charged', 'is_tax_applicable'].includes(fieldKey);

export const normalizeBoolean = (value: any): boolean => {
    if (value === true || value === 'true' || value === 1 || value === '1') return true;
    if (value === false || value === 'false' || value === 0 || value === '0' || value === null || value === undefined || value === '') return false;
    return Boolean(value);
};

export const normalizeValue = (value: any) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'boolean') return value ? 'true' : 'false';
    if (Array.isArray(value)) return [...value].sort().join(',');
    if (typeof value === 'string') return value.trim();
    return String(value);
};

export const areValuesEqual = (fieldKey: string, prev: any, current: any) => {
    const getCompareId = (val: any) => {
        if (val === null || val === undefined || val === '') return null;
        if (typeof val === 'object' && 'id' in val) return Number(val.id);
        if (typeof val === 'number') return val;
        if (typeof val === 'string' && !Number.isNaN(Number(val)) && val.trim() !== '') return Number(val);
        return null;
    };

    if (isNumericField(fieldKey)) {
        const prevId = getCompareId(prev);
        const currId = getCompareId(current);
        return prevId === currId;
    }

    if (isBooleanField(fieldKey)) {
        return normalizeBoolean(prev) === normalizeBoolean(current);
    }

    if (Array.isArray(prev) || Array.isArray(current)) {
        const normalizeArray = (arr: any[]) => {
            if (!Array.isArray(arr)) return [];
            return arr.map(v => {
                if (v && typeof v === 'object' && 'id' in v) return String(v.id);
                return String(v);
            }).sort();
        };
        return JSON.stringify(normalizeArray(prev)) === JSON.stringify(normalizeArray(current));
    }

    return normalizeValue(prev) === normalizeValue(current);
};
